import { initAnalytics, trackEvent } from "@pex/analytics/client";
import type { Metric } from "web-vitals";
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

initAnalytics({ appName: "bridge" });

const reportWebVital = (metric: Metric): void => {
  trackEvent("web_vital", {
    metric_name: metric.name,
    value: Math.round(metric.value),
    rating: metric.rating,
  });
};

onCLS(reportWebVital);
onFCP(reportWebVital);
onINP(reportWebVital);
onLCP(reportWebVital);
onTTFB(reportWebVital);
